module.exports = [{
      plugin: require('/opt/render/project/src/node_modules/gatsby-source-prismic-graphql/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"clos-mariotte","accessToken":"MC5YVWNEMmhBQUFDRUFKTXQy.BxLvv73vv73vv73vv71mJ1zvv73vv73vv73vv70TKWzvv71QNwsH77-9Fe-_ve-_ve-_vTDvv73vv73vv70077-9","path":"/preview","previews":true,"pages":[{"type":"Post","match":"/blog/:uid","path":"/blog-preview","component":"/opt/render/project/src/src/templates/post.js"}]},
    },{
      plugin: require('/opt/render/project/src/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
